<template>
  <div id="player-container">
    <div class="player">
      <iframe id="hls-player" allow="fullscreen" frameBorder="0" :src="$VUE_APP_HLS_PLAYER_URL_LIBRARY + '?url=' + url" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: ""
      };
    },
    methods: {

    },
    mounted() {
      var self = this;
      self.$store.dispatch("updateTheme", "dark");

      self.url = self.$route.query && self.$route.query.url;
    }
  };
</script>

<style lang="scss">
  #hls-player {
    width: 100%;
    height: calc(100vh - 103px);
    align-content: center;
  }
</style>
